import { bbox, buffer } from '@turf/turf';
import type { BBox, FeatureCollection, MultiPolygon, Polygon } from 'geojson';
import type { ViewState } from 'react-map-gl/mapbox';
import { getStateCapitolViewport } from '~/constants/regions/us-states';
import store from '~/store';

export const US_GEOGRAPHIC_CENTER_VIEWPORT: ViewState = {
  longitude: -98,
  latitude: 39,
  zoom: 4,
  bearing: 0,
  pitch: 0,
  padding: { top: 0, left: 0, right: 0, bottom: 0 },
};

export function getOrgStateInitialViewport(): ViewState | null {
  const org = store.currentOrganizationDetail;
  if (org.isLoading) return null;
  const viewport = getStateCapitolViewport(org.state);
  if (!viewport) return null;
  return {
    longitude: viewport.center[0],
    latitude: viewport.center[1],
    zoom: viewport.zoom,
    bearing: 0,
    pitch: 0,
    padding: { top: 0, left: 0, right: 0, bottom: 0 },
  };
}

export function getOrgStateOrUsInitialViewport(): ViewState {
  return getOrgStateInitialViewport() ?? US_GEOGRAPHIC_CENTER_VIEWPORT;
}

// CG-680: buffered bbox over all project geometry, or null if there's nothing usable to frame.
export function getProjectsFallbackBbox(polygons: FeatureCollection<Polygon | MultiPolygon>): BBox | null {
  if (!polygons.features.length) return null;
  try {
    const box = bbox(buffer(polygons, 100) ?? polygons);
    return box.every(Number.isFinite) ? box : null;
  } catch {
    return null;
  }
}
